"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.Builder = void 0;
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _settings = require("./settings.js");
var _cccisdSurveyCommon = require("cccisd-survey-common");
var _cccisdWysiwyg = _interopRequireDefault(require("cccisd-wysiwyg"));
var _style = _interopRequireDefault(require("./style.css"));
var _map2 = _interopRequireDefault(require("lodash/map"));
var _cccisdModal = _interopRequireDefault(require("cccisd-modal"));
var _sprites = _interopRequireDefault(require("../sprites.js"));
var _cccisdReduxFormHelpers = require("cccisd-redux-form-helpers");
var _ProducerVideoPicker = _interopRequireDefault(require("./ProducerVideoPicker"));
var _circleUpLeft = _interopRequireDefault(require("cccisd-icons/circle-up-left"));
var _circleUp = _interopRequireDefault(require("cccisd-icons/circle-up3"));
var _circleUpRight = _interopRequireDefault(require("cccisd-icons/circle-up-right"));
var _circleLeft = _interopRequireDefault(require("cccisd-icons/circle-left3"));
var _radioChecked = _interopRequireDefault(require("cccisd-icons/radio-checked"));
var _circleRight = _interopRequireDefault(require("cccisd-icons/circle-right3"));
var _circleDownLeft = _interopRequireDefault(require("cccisd-icons/circle-down-left"));
var _circleDown = _interopRequireDefault(require("cccisd-icons/circle-down3"));
var _circleDownRight = _interopRequireDefault(require("cccisd-icons/circle-down-right"));
var _circleUpLeft2 = _interopRequireDefault(require("cccisd-icons/circle-up-left2"));
var _circleUp2 = _interopRequireDefault(require("cccisd-icons/circle-up4"));
var _circleUpRight2 = _interopRequireDefault(require("cccisd-icons/circle-up-right2"));
var _circleLeft2 = _interopRequireDefault(require("cccisd-icons/circle-left4"));
var _radioChecked2 = _interopRequireDefault(require("cccisd-icons/radio-checked2"));
var _circleRight2 = _interopRequireDefault(require("cccisd-icons/circle-right4"));
var _circleDownLeft2 = _interopRequireDefault(require("cccisd-icons/circle-down-left2"));
var _circleDown2 = _interopRequireDefault(require("cccisd-icons/circle-down4"));
var _circleDownRight2 = _interopRequireDefault(require("cccisd-icons/circle-down-right2"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); } /** ICONS * */
var sizeOptions = [{
  value: 'small',
  label: 'Small'
}, {
  value: 'medium',
  label: 'Medium'
}, {
  value: 'large',
  label: 'Large'
}];
var Builder = exports.Builder = /*#__PURE__*/function (_React$Component) {
  _inherits(Builder, _React$Component);
  function Builder() {
    var _this;
    _classCallCheck(this, Builder);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, Builder, [].concat(args));
    // return populated dropdown of animation lables
    _defineProperty(_assertThisInitialized(_this), "_animationLabelDropdown", function (label, jsonHandle) {
      // if no selection
      if (jsonHandle === 'default' || _sprites["default"].length === 0) {
        return /*#__PURE__*/_react["default"].createElement("select", _extends({}, (0, _cccisdReduxFormHelpers.domOnlyProps)(label), {
          className: "form-control",
          style: {
            color: 'red'
          }
        }), /*#__PURE__*/_react["default"].createElement("option", {
          value: "none"
        }, "\u2014 no animation labels found \u2014"));
      }
      var handle = _sprites["default"].find(function (item) {
        return item.handle === jsonHandle;
      });
      if (handle === undefined) {
        return /*#__PURE__*/_react["default"].createElement("select", _extends({}, (0, _cccisdReduxFormHelpers.domOnlyProps)(label), {
          className: "form-control",
          style: {
            color: 'red'
          }
        }), /*#__PURE__*/_react["default"].createElement("option", {
          value: "none"
        }, "\u2014 no animation labels found \u2014"));
      }
      return /*#__PURE__*/_react["default"].createElement("select", _extends({}, (0, _cccisdReduxFormHelpers.domOnlyProps)(label), {
        className: "form-control"
      }), (0, _map2["default"])(handle.json.animations, function (l, key) {
        return /*#__PURE__*/_react["default"].createElement("option", {
          key: key,
          value: key
        }, key);
      }));
    });
    // ** Render each button **
    _defineProperty(_assertThisInitialized(_this), "_renderOriginPointButton", function (id, iconBlank, iconFilled) {
      var displayIcon = id.toUpperCase() === _this.props.fields.origin.value.toUpperCase() ? iconFilled : iconBlank;
      return /*#__PURE__*/_react["default"].createElement("button", {
        type: "button",
        className: _this._originSelectionStyles(id),
        onClick: _this.props.fields.origin.onChange.bind(null, id)
      }, displayIcon);
    });
    // ** Set the selected style of each origin point button **
    _defineProperty(_assertThisInitialized(_this), "_originSelectionStyles", function (button) {
      if (button.toUpperCase() === _this.props.fields.origin.value.toUpperCase()) {
        return 'btn btn-primary';
      }
      return 'btn btn-default';
    });
    // set sprite dimensions from js file
    _defineProperty(_assertThisInitialized(_this), "_spriteOnChange", function (e) {
      var _this$props$fields = _this.props.fields,
        type = _this$props$fields.type,
        width = _this$props$fields.width,
        height = _this$props$fields.height,
        spriteHandle = _this$props$fields.spriteHandle;
      var value = e.target.value;
      spriteHandle.onChange(value);
      var spriteWidth = 0;
      var spriteHeight = 0;
      if (type.value === 'sprite') {
        var zoeObj = _sprites["default"].find(function (item) {
          return item.handle === value;
        });
        if (zoeObj !== undefined) {
          spriteWidth = zoeObj.json.width;
          spriteHeight = zoeObj.json.height;
        }
        width.onChange(spriteWidth);
        height.onChange(spriteHeight);
      }
    });
    return _this;
  }
  _createClass(Builder, [{
    key: "render",
    value: function render() {
      var _this$props$fields2 = this.props.fields,
        type = _this$props$fields2.type,
        id = _this$props$fields2.id,
        playOnStart = _this$props$fields2.playOnStart,
        loop = _this$props$fields2.loop,
        mustWatch = _this$props$fields2.mustWatch,
        mustWatchMessage = _this$props$fields2.mustWatchMessage,
        autoAdvance = _this$props$fields2.autoAdvance,
        controls = _this$props$fields2.controls,
        volume = _this$props$fields2.volume,
        playbackRate = _this$props$fields2.playbackRate,
        width = _this$props$fields2.width,
        height = _this$props$fields2.height,
        size = _this$props$fields2.size,
        aspectRatio = _this$props$fields2.aspectRatio,
        settingsOpen = _this$props$fields2.settingsOpen,
        audio = _this$props$fields2.audio,
        spriteHandle = _this$props$fields2.spriteHandle,
        startAnimationLabel = _this$props$fields2.startAnimationLabel,
        idleAnimationLabel = _this$props$fields2.idleAnimationLabel,
        origin = _this$props$fields2.origin,
        marginOverride = _this$props$fields2.marginOverride,
        marginValX = _this$props$fields2.marginValX,
        marginValY = _this$props$fields2.marginValY;
      var warnings = [];
      if (type.value !== 'sprite') {
        if (playOnStart.value) {
          warnings.push( /*#__PURE__*/_react["default"].createElement("div", {
            className: _style["default"].warning,
            key: "mobileAutoplay"
          }, "Auto-play not available in most cases"));
        }
        if (!controls.value) {
          warnings.push( /*#__PURE__*/_react["default"].createElement("div", {
            className: _style["default"].warning,
            key: "mobileControls"
          }, "Controls will be shown in most cases"));
        }
        if (!playOnStart.value && !controls.value) {
          warnings.push( /*#__PURE__*/_react["default"].createElement("div", {
            className: _style["default"].warning,
            key: "noWayToPlay"
          }, "There may not be a way to play this video"));
        }
      }

      // suppress percentages for sprites
      var sizeType = type.value === 'sprite' ? 'number' : 'text';
      var hideAdvancedTypes = ['basic', 'premium'].includes(this.props.restrictionsLevel);
      var form = /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement(_cccisdSurveyCommon.FieldBlock, {
        field: type,
        label: "Type"
      }, /*#__PURE__*/_react["default"].createElement("select", _extends({}, (0, _cccisdReduxFormHelpers.domOnlyProps)(type), {
        className: "form-control"
      }), /*#__PURE__*/_react["default"].createElement("option", {
        value: "vimeo"
      }, "Vimeo"), /*#__PURE__*/_react["default"].createElement("option", {
        value: "youtube"
      }, "YouTube"), /*#__PURE__*/_react["default"].createElement("option", {
        value: "file"
      }, "MP4"), !hideAdvancedTypes && _sprites["default"].length > 0 && /*#__PURE__*/_react["default"].createElement("option", {
        value: "sprite"
      }, "Sprite"), !hideAdvancedTypes && /*#__PURE__*/_react["default"].createElement("option", {
        value: "producer"
      }, "Producer"))), type.value !== 'sprite' && /*#__PURE__*/_react["default"].createElement("div", null, type.value === 'producer' ? /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_cccisdSurveyCommon.FieldBlock, {
        field: id,
        label: id.value ? /*#__PURE__*/_react["default"].createElement("span", null, "ID: ", /*#__PURE__*/_react["default"].createElement("span", {
          style: {
            fontWeight: 'normal'
          }
        }, id.value)) : 'ID:'
      }, /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement(_cccisdModal["default"], {
        title: "Pick video",
        size: "large",
        trigger: /*#__PURE__*/_react["default"].createElement("button", {
          type: "button",
          className: "btn btn-default btn-sm"
        }, "Pick video")
      }, /*#__PURE__*/_react["default"].createElement(_ProducerVideoPicker["default"], {
        onChange: id.onChange
      })))), /*#__PURE__*/_react["default"].createElement(_cccisdSurveyCommon.FieldBlock, {
        field: size,
        label: "Video size"
      }, /*#__PURE__*/_react["default"].createElement("div", null, sizeOptions.map(function (option) {
        return /*#__PURE__*/_react["default"].createElement("label", {
          key: option.value,
          className: "radio-inline"
        }, /*#__PURE__*/_react["default"].createElement("input", {
          type: "radio",
          onChange: function onChange() {
            return size.onChange(option.value);
          },
          value: option.value,
          checked: size.value === option.value
        }), ' ', option.label);
      })))) : /*#__PURE__*/_react["default"].createElement(_cccisdSurveyCommon.TextBlock, {
        field: id,
        label: ['vimeo', 'youtube'].includes(type.value) ? 'ID:' : 'URL of Video File:'
      }), /*#__PURE__*/_react["default"].createElement(_cccisdSurveyCommon.FieldBlock, {
        field: volume,
        label: "Volume"
      }, /*#__PURE__*/_react["default"].createElement("input", _extends({
        type: "number",
        min: "0",
        max: "1",
        step: "0.01",
        className: "form-control"
      }, (0, _cccisdReduxFormHelpers.domOnlyProps)(volume)))), /*#__PURE__*/_react["default"].createElement(_cccisdSurveyCommon.FieldBlock, {
        field: playbackRate,
        label: "Rate"
      }, /*#__PURE__*/_react["default"].createElement("input", _extends({
        type: "number",
        min: "0",
        max: "1",
        className: "form-control"
      }, (0, _cccisdReduxFormHelpers.domOnlyProps)(playbackRate))))), type.value === 'sprite' && /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement(_cccisdSurveyCommon.FieldBlock, {
        field: spriteHandle,
        label: "Sprite"
      }, /*#__PURE__*/_react["default"].createElement("select", _extends({}, (0, _cccisdReduxFormHelpers.domOnlyProps)(spriteHandle), {
        className: "form-control",
        onChange: this._spriteOnChange
      }), /*#__PURE__*/_react["default"].createElement("option", {
        value: "default"
      }, "\u2014 SELECT FILE \u2014"), (0, _map2["default"])(_sprites["default"], function (sprite) {
        return /*#__PURE__*/_react["default"].createElement("option", {
          key: sprite.handle,
          value: sprite.handle
        }, sprite.label);
      }))), /*#__PURE__*/_react["default"].createElement(_cccisdSurveyCommon.FieldBlock, {
        field: startAnimationLabel,
        label: "Start Animation Label"
      }, this._animationLabelDropdown(startAnimationLabel, spriteHandle.value)), /*#__PURE__*/_react["default"].createElement(_cccisdSurveyCommon.FieldBlock, {
        field: idleAnimationLabel,
        label: "Idle Animation Label"
      }, this._animationLabelDropdown(idleAnimationLabel, spriteHandle.value)), /*#__PURE__*/_react["default"].createElement(_cccisdSurveyCommon.FieldBlock, {
        field: audio,
        label: "Audio File"
      }, /*#__PURE__*/_react["default"].createElement(_cccisdWysiwyg["default"], {
        content: audio.value,
        type: "textarea-inline",
        onChange: audio.onChange,
        selectAllOnFocus: audio.value === _settings.initialValues.audio
      })), /*#__PURE__*/_react["default"].createElement(_cccisdSurveyCommon.FieldBlock, {
        field: width,
        label: "Width"
      }, /*#__PURE__*/_react["default"].createElement("input", _extends({
        type: sizeType,
        className: "form-control"
      }, (0, _cccisdReduxFormHelpers.domOnlyProps)(width)))), /*#__PURE__*/_react["default"].createElement(_cccisdSurveyCommon.FieldBlock, {
        field: height,
        label: "Height"
      }, /*#__PURE__*/_react["default"].createElement("input", _extends({
        type: sizeType,
        className: "form-control"
      }, (0, _cccisdReduxFormHelpers.domOnlyProps)(height))))), type.value !== 'sprite' && /*#__PURE__*/_react["default"].createElement(_cccisdSurveyCommon.FieldBlock, {
        field: aspectRatio,
        label: "Aspect Ratio"
      }, /*#__PURE__*/_react["default"].createElement("select", _extends({}, (0, _cccisdReduxFormHelpers.domOnlyProps)(aspectRatio), {
        className: "form-control"
      }), /*#__PURE__*/_react["default"].createElement("option", {
        value: "16/9"
      }, "16/9"), /*#__PURE__*/_react["default"].createElement("option", {
        value: "4/3"
      }, "4/3"), /*#__PURE__*/_react["default"].createElement("option", {
        value: "1/1"
      }, "1/1"))), type.value === 'sprite' && /*#__PURE__*/_react["default"].createElement(_cccisdSurveyCommon.FieldBlock, {
        field: origin,
        label: "Scaling Origin Point"
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: _style["default"].originPointBtnRow
      }, this._renderOriginPointButton('TL', /*#__PURE__*/_react["default"].createElement(_circleUpLeft["default"], null), /*#__PURE__*/_react["default"].createElement(_circleUpLeft2["default"], null)), this._renderOriginPointButton('TC', /*#__PURE__*/_react["default"].createElement(_circleUp["default"], null), /*#__PURE__*/_react["default"].createElement(_circleUp2["default"], null)), this._renderOriginPointButton('TR', /*#__PURE__*/_react["default"].createElement(_circleUpRight["default"], null), /*#__PURE__*/_react["default"].createElement(_circleUpRight2["default"], null))), /*#__PURE__*/_react["default"].createElement("div", {
        className: _style["default"].originPointBtnRow
      }, this._renderOriginPointButton('CL', /*#__PURE__*/_react["default"].createElement(_circleLeft["default"], null), /*#__PURE__*/_react["default"].createElement(_circleLeft2["default"], null)), this._renderOriginPointButton('CC', /*#__PURE__*/_react["default"].createElement(_radioChecked["default"], null), /*#__PURE__*/_react["default"].createElement(_radioChecked2["default"], null)), this._renderOriginPointButton('CR', /*#__PURE__*/_react["default"].createElement(_circleRight["default"], null), /*#__PURE__*/_react["default"].createElement(_circleRight2["default"], null))), /*#__PURE__*/_react["default"].createElement("div", {
        className: _style["default"].originPointBtnRow
      }, this._renderOriginPointButton('BL', /*#__PURE__*/_react["default"].createElement(_circleDownLeft["default"], null), /*#__PURE__*/_react["default"].createElement(_circleDownLeft2["default"], null)), this._renderOriginPointButton('BC', /*#__PURE__*/_react["default"].createElement(_circleDown["default"], null), /*#__PURE__*/_react["default"].createElement(_circleDown2["default"], null)), this._renderOriginPointButton('BR', /*#__PURE__*/_react["default"].createElement(_circleDownRight["default"], null), /*#__PURE__*/_react["default"].createElement(_circleDownRight2["default"], null)))), type.value === 'sprite' && /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement("input", _extends({
        type: "checkbox"
      }, (0, _cccisdReduxFormHelpers.domOnlyProps)(marginOverride))), "\xA0 ", /*#__PURE__*/_react["default"].createElement("span", {
        className: _style["default"].bold
      }, "Override Margins")), marginOverride.value && /*#__PURE__*/_react["default"].createElement("div", {
        className: _style["default"].hiddenBlock
      }, /*#__PURE__*/_react["default"].createElement(_cccisdSurveyCommon.TextBlock, {
        field: marginValX,
        label: "Margin X-axis"
      }), /*#__PURE__*/_react["default"].createElement(_cccisdSurveyCommon.TextBlock, {
        field: marginValY,
        label: "Margin Y-axis"
      }))), /*#__PURE__*/_react["default"].createElement("hr", null), /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement("input", _extends({
        type: "checkbox"
      }, (0, _cccisdReduxFormHelpers.domOnlyProps)(playOnStart))), "\xA0 Autoplay"), type.value !== 'sprite' && /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement("input", _extends({
        type: "checkbox"
      }, (0, _cccisdReduxFormHelpers.domOnlyProps)(controls))), "\xA0 Show controls"), !this.props.isIncludedMode && /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement("input", _extends({
        type: "checkbox"
      }, (0, _cccisdReduxFormHelpers.domOnlyProps)(loop), {
        disabled: autoAdvance.value
      })), "\xA0 ", /*#__PURE__*/_react["default"].createElement("span", {
        className: autoAdvance.value ? _style["default"].disableGray : ''
      }, "Loop")), /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement("input", _extends({
        type: "checkbox"
      }, (0, _cccisdReduxFormHelpers.domOnlyProps)(mustWatch))), "\xA0 Must Watch Video"), mustWatch.value && /*#__PURE__*/_react["default"].createElement("div", {
        className: _style["default"].hiddenBlock
      }, /*#__PURE__*/_react["default"].createElement(_cccisdSurveyCommon.TextBlock, {
        field: mustWatchMessage,
        label: "Must Watch Error Message"
      })), /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement("input", _extends({
        type: "checkbox"
      }, (0, _cccisdReduxFormHelpers.domOnlyProps)(autoAdvance), {
        disabled: loop.value
      })), "\xA0 ", /*#__PURE__*/_react["default"].createElement("span", {
        className: loop.value ? _style["default"].disableGray : ''
      }, "Auto Advance On End"))), /*#__PURE__*/_react["default"].createElement("div", {
        className: _style["default"].warnings
      }, warnings));
      return this.props.isIncludedMode ? form : /*#__PURE__*/_react["default"].createElement(_cccisdSurveyCommon.FormBlock, {
        title: "Settings",
        type: "primary",
        show: settingsOpen.value,
        handleClick: function handleClick(show) {
          return settingsOpen.onChange(show);
        }
      }, form);
    }
  }]);
  return Builder;
}(_react["default"].Component);
_defineProperty(Builder, "propTypes", {
  fields: _propTypes["default"].object,
  /** video could be part of another component like cccisd-survey-list */
  isIncludedMode: _propTypes["default"].bool
});
var _default = exports["default"] = (0, _cccisdSurveyCommon.builderWrapper)({
  fields: _settings.fields,
  validate: _settings.validate,
  initialValues: _settings.initialValues,
  withTemplate: true,
  withAccommodations: true
})(Builder);